import { Link, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (<>
    <main className="dvh-full grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-blue-600">Oops!</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">{error.statusText || error.message}</h1>
        <p className="mt-6 text-base leading-7 text-gray-600">Sorry, an error has occurred.</p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link to={'/'} className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Go back home</Link>
        </div>
      </div>
    </main>
    </>
  );
}